import React, { Component } from "react";
import FormComponent from "../../Form/FormComponent";
import { addUser } from "./UserConfig";
import { TextField, Button, Chip, FormHelperText } from "@material-ui/core";
import { saveUserdata, getUserDataById, getAllSites } from "./UserQueries";
import { mutationQueries } from "../../MutationMethod";
import { fetchMethod, debounce } from "../../FetchMethod";
import { FadeLoader } from "react-spinners";
import SnackBarComponent from "../../SnackBar/SnackBar";
import gql from "graphql-tag";

import Autocomplete from "@material-ui/lab/Autocomplete";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
class EditUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chipArray: [],
      loading: true,
      editableData: undefined,
      id: this.props.location.state ? this.props.location.state.id : "",
      open: false,
      severity: "",
      alertmsg: "",
      siteArray: [],
      newsiteArray: [],
      siteData: [],
      siteobj: { id: "", name: "" },
      disableaddsite: false,
      saveButtonDisabled: false,
    };
  }
  componentDidMount() {
    this.state.id ? this.getUserFormData() : this.props.history.push("/users");
  }
  getUserFormData = () => {
    let { chipArray } = this.state;
    fetchMethod(getUserDataById(this.state.id))
      .then((res) => res.json())
      .then((res) => {
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        if (res.errors) {
          this.setState({
            open: true,
            severity: "error",
            alertmsg: res.errors.length ? res.errors[0].message : "",
          });
        }
        if (res.data.allUserdata) {
          if (res.data.allUserdata.Userdata.length) {
            chipArray = res.data.allUserdata.Userdata[0].mappedUser.Usersitemaps.map(
              (item) => {
                if (item.mappedsiterel.Sites.length) {
                  return {
                    label: item.mappedsiterel.Sites.length
                      ? item.mappedsiterel.Sites[0].name
                      : "",
                    name: item.mappedsiterel.Sites.length
                      ? item.mappedsiterel.Sites[0].name
                      : "",
                    id: item.id,
                    usersiteid: item.id,
                    siteid: item.siteid,
                    active: item.active,
                  };
                } else {
                  return null;
                }
              }
            );
            chipArray = chipArray.filter((items) => items != null).length
              ? chipArray.filter((items) => items != null)
              : [];
          }
          // let editArray=res.data.allUserdata.Userdata[0]
          let { mappedUser, ...editArray } = res.data.allUserdata.Userdata[0];
          // editArray.istrained = editArray.istrained === 1 ? true : false;
          this.setState({
            editableData: res.data.allUserdata.Userdata.length ? editArray : {},
            prevEmail : res.data.allUserdata.Userdata.length ? editArray.email : {},
            prevNumber : res.data.allUserdata.Userdata.length ? editArray.phonenumber : {},
            prevRole : res.data.allUserdata.Userdata.length ? editArray.role : {},
            loading: false,
            chipArray,
            siteArray: chipArray,
          });
        }
      })
      .catch((e) => {
        this.setState({ loading: false });
        console.log(e);
      });
  };
  getSites = () => {
    fetchMethod(getAllSites, {
      where: {
        and: [
          {
            or: [
              { name: { like: `%${this.state.siteName}%` } },
              { siteid: { like: `%${this.state.siteName}%` } },
            ],
          },
          {
            active: 1,
          },
        ],
      },
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        this.setState({
          siteData: res.data.allSites
            ? res.data.allSites.Sites.map((item) => {
                item.name = `${item.siteid}, ${item.name}`;
                return item;
              })
            : [],
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };
  Users = () => {
    this.props.history.push("/users");
  };
  siteArrayValidation = () => {
    if (this.state.chipArray.length) {
      let activeChipArray = this.state.chipArray.filter(
        (item) => item.active === 1
      );
      if (activeChipArray.length == 0) {
        this.setState({
          errorSiteMessage: "Site is mandatory.",
        });
        return true;
      } else return false;
    } else {
      this.setState({
        errorSiteMessage: "Site is mandatory.",
      });
      return true;
    }
  };
  preSubmitChanges = (e) => {
    this.setState({ loading: true, saveButtonDisabled: true });
    e.active = 1;
    let {prevEmail , prevNumber , prevRole} = this.state
    // e.istrained = e.istrained ? 1 : 0;
    delete e.sendwelcomeemail;
    mutationQueries(saveUserdata, { obj: e })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.saveUserdata) {
          if (prevEmail === localStorage.getItem("email") &&( prevEmail !== e.email || prevRole !== e.role)){
            localStorage.clear()
            this.setState({
              open:true,
              severity : "success",
              alertmsg : "Your account has been updated. Please sign in again."
            }, ()=> {
              setTimeout(()=>{ 
              window.location = "/";
              },1000)
          })
        }
        else {
          this.userSiteMap(res.data.saveUserdata.id, e.role !== "ADMIN");
          this.setState(
            {
              open: true,
              severity: "success",
              alertmsg: (prevEmail=== localStorage.getItem("email") && (prevEmail !==e.email || prevRole !== e.role)) ? "Your account has been updated. Please sign in again.":"User Updated Successfully!",
            },
            () => {
              setTimeout(() => {
                this.props.history.push("/users");
              }, 2000);
            }
          );}
        }
        if (res.error && res.error.statusCode === 401) {
          localStorage.clear();
          window.location = "/";
        }
        if (res.errors) {
          this.setState({
            open: true,
            severity: "error",
            alertmsg: res.errors.length ? res.errors[0].message : "",
            saveButtonDisabled: false,
          });
        }
      })
      .catch((e) => {
        this.setState({
          open: true,
          severity: "error",
          alertmsg: e.message.toString().split(":")[2].replace(/"/g, ""),
          loading: false,
          saveButtonDisabled: false,
        });
        console.log(e);
      });
    return true;
  };
  userSiteMap = (userid, isrole) => {
    let { chipArray } = this.state;
    let query = "";
    if (chipArray && chipArray.length && isrole) {
      chipArray.map((item, index) => {
        if (item.usersiteid)
          query += `id${index}: saveUsersitemap(
          obj: {
            active:${item.active},
            id:${item.usersiteid},
           userid:${userid}
          }
        ){id}`;
        else if (item.active)
          query += `id${index}: saveUsersitemap(
          obj: {
            active:${item.active},
            siteid:${item.id},
           userid:${userid}
          }
        ){id}`;
      });
    }

    if (query !== "") {
      mutationQueries(gql`mutation{${query}}`)
        .then((res) => {})
        .catch((e) => {
          this.setState({
            open: true,
            severity: "error",
            alertmsg: e.message,
            loading: false,
          });
          console.log(e);
        });
    }
  };
  handleTextField = (e) => {
    const {
      target: { name, value },
    } = e;
    this.setState({ [name]: value });
  };

  handleSelect = (e, value) => {
    let siteobj = value;
    if (siteobj) {
      if (siteobj.id) {
        this.setState(
          { siteName: value.name, siteobj, errorSiteMessage: "" },
          () =>
            this.state.siteName.length >= 2
              ? this.getSites()
              : this.setState({ siteData: [] })
        );
      } else {
        this.setState(
          {
            siteName: value,
            siteobj: {
              name: value,
              id: 0,
            },
            errorSiteMessage: "",
          },
          () =>
            this.state.siteName.length >= 2
              ? this.getSites()
              : this.setState({ siteData: [] })
        );
      }
    } else {
      // this.setState({
      //   siteName: "",
      //   siteobj: {
      //     name: "",
      //     id: 0,
      //   },
      // });
    }
  };
  buttonClicked = async (e) => {
    this.setState({ disableaddsite: true });
    let { siteName, chipArray, newsiteArray, siteobj } = this.state;
    if (siteName !== undefined && siteName !== null && siteName !== "") {
      if (siteobj.id) {
        if (chipArray !== undefined && chipArray.length) {
          if (
            chipArray.filter((item) => item.siteid === siteobj.id).length === 0
          )
            chipArray.push({
              name: siteName,
              label: siteName,
              id: siteobj.id,
              siteid: siteobj.id,
              active: 1,
              usersiteid: null,
            });
          if (
            chipArray.filter(
              (item) => item.siteid === siteobj.id && item.active === 0
            ).length
          ) {
            chipArray.map((item) =>
              item.siteid === siteobj.id && item.active === 0
                ? Object.assign(item, { active: 1 })
                : item
            );
          }
        } else {
          chipArray = [
            {
              name: siteName,
              label: siteName,
              id: siteobj.id,
              siteid: siteobj.id,
              active: 1,
              usersiteid: null,
              // ,siteid:siteobj.id
            },
          ];
        }
        siteName = "";
        siteobj = { id: "", name: "" };
      } else {
        // let variable = {
        //   name: siteName,
        //   active: 1,
        // };
      }

      this.setState({ siteobj, disableaddsite: false });
    }
    this.setState({ chipArray, siteName, newsiteArray, disableaddsite: false });
  };
  handleChipDelete = async (index, e) => {
    let { chipArray, newsiteArray } = this.state;
    let options = chipArray;
    let { name, ...removeSiteObj } = options[index];
    if (removeSiteObj !== undefined) {
      if (removeSiteObj.id) {
        chipArray = options.map((items, ind) =>
          ind === index ? Object.assign(items, { active: 0 }) : items
        );
      }
    }
    this.setState({ chipArray, newsiteArray });
  };
  keyPress = (e) => {
    if (e.keyCode === 13) {
      this.setState({ disableaddsite: true });
      this.debounceTimer = debounce(
        this.debounceTimer,
        () => this.buttonClicked(e),
        100
      );
    }
  };
  SitesSection = () => {
    return (
      <React.Fragment>
        <div className="chipSection">
          {this.state.chipArray
            ? this.state.chipArray.map((chipitem, index) => {
                return chipitem.active ? (
                  // <li key={index}>
                  <Chip
                    label={chipitem.label}
                    onDelete={(e) => this.handleChipDelete(index, e)}
                    key={index}
                  />
                ) : (
                  // </li>
                  ""
                );
              })
            : ""}
        </div>
        <div className="siteSections">
          <div>
            <Autocomplete
              // freeSolo
              id="siteName"
              options={this.state.siteData}
              getOptionLabel={(option) => {
                return option !== undefined
                  ? option.name
                    ? option.name
                    : ""
                  : option;
              }}
              style={{ width: "100%" }}
              value={this.state.siteobj}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Site Name"
                  margin="normal"
                  value={this.state.siteName}
                  name={"siteName"}
                  InputProps={{
                    ...params.InputProps,
                    className: "searchsiteicon",
                    autoComplete: "samlpetexttodisable",
                    endAdornment: <SearchIcon />,
                  }}
                ></TextField>
              )}
              getOptionSelected={(options, value) =>
                value.value === options.value
              }
              onChange={this.handleSelect}
              onInputChange={this.handleSelect}
              onKeyDown={this.keyPress}
            />
            {this.state.errorSiteMessage ? (
              <FormHelperText>{this.state.errorSiteMessage}</FormHelperText>
            ) : (
              ""
            )}
          </div>
          <div>
            <Button
              onClick={this.buttonClicked}
              disabled={this.state.disableAddSite}
            >
              <AddIcon />
              Add Site
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  };
  handleSnackBarClose = () => {
    let { severity } = this.state;
    this.setState({ open: false, severity: "", alertmsg: "" });
    if (severity === "success") this.props.history.push("/users");
  };
  render() {
    let { fields } = addUser;
    let editUserConfig = addUser;
    let { editableData } = this.state;
    let obj = fields.filter((items) => items.name === "sendwelcomeemail");
    obj = obj[0];
    obj.type = "";
    fields = fields.map((items) => {
      if (items.name === "sendwelcomeemail") items = obj;
      // if (items.name === "email") items.readOnly = true;
      // if (items.name === "phonenumber") items.readOnly = true;
      return items;
    });
    if (editableData) {
      if (editableData.role == "ADMIN")
        editUserConfig.fields = fields.filter(
          (item) => item.name !== "SitesName" && item.label !== "Sites"
        );
      else {
        let updatedFields = fields.filter((items) => items.label === "Sites")
          .length
          ? fields
          : fields.push({ type: "heading", label: "Sites" });
        updatedFields = fields.filter((items) => items.name === "SitesName")
          .length
          ? fields
          : fields.push({
              type: "content",
              name: "SitesName",
              required: true,
            });
        editUserConfig.fields = fields;
      }
    }
    return (
      <div className="addUserSection">
        {this.state.loading ? (
          <div className="Loader">
            <FadeLoader
              style={{ height: "15", width: "5", radius: "2" }}
              color={"#6FABF0"}
              loading={this.state.loading}
            />
          </div>
        ) : (
          ""
        )}
        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            handleClose={this.handleSnackBarClose}
            className="addUserSnackBar"
          />
        ) : (
          ""
        )}
        <ul className="sitepath">
          <li onClick={this.Users} style={{ cursor: "pointer" }}>
            Users
          </li>
          <li>
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.992"
                height="8"
                viewBox="0 0 13.992 8"
              >
                <defs></defs>
                <path
                  className="a"
                  d="M13.186,16.835l5.291-5.295a1,1,0,0,1,1.412,0,1.008,1.008,0,0,1,0,1.416l-5.995,6a1,1,0,0,1-1.379.029L6.479,12.961a1,1,0,0,1,1.412-1.416Z"
                  transform="translate(-6.188 -11.246)"
                />
              </svg>
            </span>
          </li>
          <li> Edit User</li>
        </ul>
        <h3>Edit User</h3>
        {this.state.editableData ? (
          <FormComponent
            formConfig={editUserConfig}
            showContentOnForm={{ SitesName: this.SitesSection }}
            query={saveUserdata}
            preSubmitChanges={this.preSubmitChanges}
            editableData={this.state.editableData}
            saveButtonDisabled={this.state.saveButtonDisabled}
            contentValidationOnForm={{ SitesName: this.siteArrayValidation }}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default EditUserForm;
